export enum EEopTemplates {
    'REMs EOP' = 1,
    'AL EOP' = 2,
    'MS EOP' = 3
}

export enum ESectionTypes {
    "Core Planning Team" = 1,
    "ICS Roles" = 2,
    "Schedule" = 3,
    "Assessments" = 4,
    "Threat & Hazard" = 5,
    "Functions - Goals and Objectives" = 6,
    "Threat/Hazard - Goals and Objectives" = 7,
    "Functional Assignments" = 8,
    "Function - Courses of Action" = 9,
    "Threat/Hazard - Courses of Action" = 10,
    "Introductory Materials" = 11,
    "Purpose and Situation Overview" = 12,
    "Concept of Operations" = 13,
    "Organization and Assignment of Responsibilities" = 14,
    "Direction, Control, and Coordination" = 15,
    "Information Collection, Analysis, and Dissemination" = 16,
    "Training and Exercises" = 17,
    "Administration, Finance, and Logistics" = 18,
    "Plan Development and Maintenance" = 19,
    "Authorities and References" = 20,
    "Custom EOP Page" = 21
}

export enum ESubSectionTypes {
    "Promulgation" = 1,
    "Approval Implementation" = 2,
    "Record of Changes" = 3,
    "Record of Distribution" = 4,
    "Purpose" = 5,
    "Scope" = 6,
    "Situation Overview" = 7,
    "Planning Assumptions" = 8
}

export enum ESectionRoutes {
    "core-planning-team" = 1,
    "nims-ics" = 2,
    "schedule" = 3,
    "assessments" = 4,
    "threats-hazards" = 5,
    "functions" = 6,
    "threats-hazards-objectives" = 7, 
    "functional-assignments" = 8, 
    "functions-courses-of-action" = 9, 
    "threats-hazards-courses-of-action" = 10,
    
    "introductory-materials" = 11,
    "purpose-situation-overview" = 12,
    "concept-of-operations" = 13,
    "organization-assignment-of-responsibilities" = 14,
    "direction-control-coordination" = 15,
    "information-collection-analysis-dissemination" = 16,
    "training-exercises" = 17,
    "administration-finance-logistics" = 18,
    "plan-development-maintenance" = 19,
    "authorities-references" = 20
    // custom EOP page has dynamic route
}

export enum EAssessmentTypes {
    "Site" = 1,
    "Capacity" = 2,
    "Climate" = 3
}

export enum EAssessmentSubTypes {
    "School Grounds" = 1,
    "Classrooms" = 2,
    "Evacuation Routes" = 3,
    "Neighborhoods and Communities" = 4,
    "Skills Survey" = 5,
    "Instructional Staff" = 6,
    "Non-Instructional Staff" = 7,
    "Parent" = 8,
    "Student" = 9,
}

export enum EGoalTypes {
    "Before" = 1,
    "During" = 2,
    "After" = 3
}

export enum EScheduleTypes {
    "Training" = 1,
    "Drills" = 2,
    "Meeting" = 3
}

export function getSectionNameFromRoute(route: string): string | undefined {
    const sectionId = ESectionRoutes[route as keyof typeof ESectionRoutes];
  
    if (!sectionId) return undefined;
    return ESectionTypes[sectionId];
  }
